type BranchOption = { id: string; name: string };

type Props = {
  value: string;
  onChange: (branchId: string) => void;
  branches: BranchOption[];
  className?: string;
  disabled?: boolean;
  includeAllOption?: boolean;
  emptyOptionLabel?: string;
};

export function BranchFilterSelect({
  value,
  onChange,
  branches,
  className = "kp-input",
  disabled,
  includeAllOption = true,
  emptyOptionLabel,
}: Props) {
  const emptyLabel = emptyOptionLabel ?? (includeAllOption ? "Tum subeler" : "Sube secin");

  return (
    <select
      className={className}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      aria-label="Sube filtresi"
    >
      <option value="">{emptyLabel}</option>
      {branches.map((b) => (
        <option key={b.id} value={b.id}>
          {b.name}
        </option>
      ))}
    </select>
  );
}
